import { ApplicationRef, computed, inject, Injectable, signal, Signal } from '@angular/core';

/**
 * Service for managing global loading state
 * Uses a counter pattern to handle multiple simultaneous requests
 */
@Injectable({ providedIn: 'root' })
export class LoaderService {
  /** Application reference for manual change detection in zoneless mode */
  private readonly _appRef = inject(ApplicationRef);

  /** Counter for active loading requests */
  private readonly _counter = signal(0);

  /** Computed signal indicating if any request is loading */
  private readonly _isLoading = computed(() => this._counter() > 0);

  /**
   * Show loader (increment counter)
   */
  public show(): void {
    this._counter.update((value) => value + 1);
  }

  /**
   * Hide loader (decrement counter, minimum 0)
   */
  public hide(): void {
    this._counter.update((value) => Math.max(0, value - 1));
    // Force change detection in zoneless mode when counter changes
    this._appRef.tick();
  }

  /**
   * Get loading state as signal (for zoneless compatibility)
   * @returns Signal of loading state
   */
  public isLoading(): Signal<boolean> {
    return this._isLoading;
  }
}
